import React, { useState, useEffect } from "react";
import {
  ScrollView,
  Alert,
  Dimensions,
  StyleSheet,
  View,
  Image,
} from "react-native";

import AppButton from "../components/AppButton";
import AppText from "../components/AppText";
import Screen from "../components/Screen";
import colors from "../config/colors";
import { StdAlert } from "./CustomAlert";
import MultipleEntryButton from "./MultipleEntryButton";

function MultipleOptionScreen({
  field,
  data,
  item,
  enteredData,
  onNextPress,
  onPrevious,
  max = 2,
  first = false,
  last = false,
}) {
  const [entries, setEntries] = useState([data[0].qoption_statement]);

  useEffect(() => {
    const newData = enteredData || {};
    // newData[field] = entries;

    // const getEntryKey = data[dataKey];
    console.log([data[0].qoption_statement], "ksjf");
    if (!newData.options[field]) {
      setEntries([data[0].qoption_statement]);
    } else {
      const newArray = [];
      Object.keys(newData.options[field]).map((entry) => {
        console.log(entry, "ofj");
        newArray.push(entry);
      });
      setEntries(newArray);
    }
  }, [data]);

  const onEntrySelect = (fieldEntry) => {
    const newData = [...entries];
    let index = newData.findIndex((x) => x === fieldEntry);
    // const index = newData.indexOf(fieldEntry);
    if (index > -1) {
      newData.splice(index, 1);
    } else {
      if (newData.length < max) {
        newData.push(fieldEntry);
      } else {
        return StdAlert("", `Please, select any ${max}.`);
        // return Alert.alert("", `Please, select any ${max}.`);
      }
    }
    console.log(newData, "kls");
    setEntries(newData);
  };

  const onNext = () => {
    if (entries.length > 0) {
      const newData = enteredData || {};
      // newData[field] = entries;

      let totalPoints = parseInt(newData["totalPoints"] || 0);
      // const getEntryKey = data[dataKey];
      if (newData.options[field]) {
        Object.keys(newData.options[field]).map((entry) => {
          const fieldPoints = parseInt(newData.options[field][entry]);
          totalPoints -= fieldPoints;
        });
        delete newData.options[field];
      }
      // console.log(entries, field, "ouuy");
      entries.map((entryKey) => {
        let index = data.findIndex((x) => x.qoption_statement === entryKey);
        const fieldPoints = parseInt(data[index].qoption_marks);
        totalPoints += fieldPoints;
        const new_entry = {
          [entryKey]: data[index].qoption_marks,
        };
        // console.log(new_entry, entryKey, data[field][entryKey], "hj");
        let totalEntries = Object.assign(
          newData.options[field] || {},
          new_entry
        );
        newData.options[field] = totalEntries;
      });
      newData["totalPoints"] = totalPoints;
      // newData[field] = entrySelected;
      // console.log(newData, "lk");
      // const newData = newData || {};
      // console.log(newData, "oi");

      let multipleTotal = 0;

      Object.keys(newData.options[field]).map((item) => {
        const itemValue = parseInt(newData.options[field][item]);
        multipleTotal += itemValue;
      });

      const recommendation_marks = parseInt(
        item.question_recommendation_marks || "0"
      );
      delete newData.submission_recommendation[field];
      if (multipleTotal < recommendation_marks) {
        newData.submission_recommendation[field] = item.question_recommendation;
      }

      console.log(newData, "klsdfer");

      onNextPress(newData);
    } else {
      return StdAlert("", "Please, select at least 1");
      // return Alert.alert("", "Please, select at least 1");
    }
  };
  return (
    <Screen style={styles.container}>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          justifyContent: "center",
        }}
      >
        <Image
          source={require("../assets/paris_portrait.jpg")}
          style={{
            height: "100%",
            width: "100%",
            position: "absolute",
            // resizeMode: "contain",
          }}
        />
        <View
          style={{
            backgroundColor: colors.primaryTrans,
            height: "100%",
            justifyContent: "center",
          }}
        >
          <AppText
            color="transparent"
            textColor="white"
            style={{
              alignSelf: "center",
              fontSize: 20,
              fontWeight: "700",
              marginTop: 10,
              marginHorizontal: 20,
              textAlign: "center",
            }}
          >
            {field}
          </AppText>
          <AppText
            color="transparent"
            textColor="white"
            style={{
              alignSelf: "center",
              fontSize: 18,
              fontWeight: "700",
              marginBottom: 20,
            }}
          >
            Select max. {max}
          </AppText>
          {data.map((fieldEntry) => {
            if (fieldEntry !== "max") {
              return (
                <MultipleEntryButton
                  key={fieldEntry.record_id}
                  title={fieldEntry.qoption_statement}
                  entries={entries}
                  onPress={() => onEntrySelect(fieldEntry.qoption_statement)}
                />
              );
            }
          })}
          {!last && (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              {!first && (
                <AppButton
                  style={{
                    alignSelf: "center",
                    marginBottom: 10,
                    marginRight: 10,
                  }}
                  color="skyblue"
                  textColor="white"
                  title="Previous"
                  onPress={onPrevious}
                />
              )}
              <AppButton
                style={{
                  alignSelf: "center",
                  marginBottom: 10,
                  marginLeft: 10,
                }}
                color="yellow"
                textColor="black"
                title="Next"
                onPress={onNext}
              />
            </View>
          )}
          {last && (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <AppButton
                style={{
                  alignSelf: "center",
                  marginBottom: 10,
                  marginRight: 10,
                }}
                color="skyblue"
                textColor="white"
                title="Previous"
                onPress={onPrevious}
              />
              <AppButton
                style={{ alignSelf: "center", width: 200, marginBottom: 10 }}
                color="skyblue"
                textColor="white"
                title="Check my Score"
                onPress={onNext}
              />
            </View>
          )}
        </View>
      </ScrollView>
    </Screen>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 1.0 * Dimensions.get("window").width,
    flex: 1,
  },
  button: {
    margin: 20,
    alignSelf: "center",
    width: "80%",
  },
});

export default MultipleOptionScreen;
